import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CostCenter } from "../_types/costCenter";

@Injectable({
    providedIn: 'root',
})

export class CostCentersService extends Service<CostCenter> {
  public override type = 'costsCenters';
  public override url = 'invoicing/costsCenters'; 
    
}
